import { useContext } from "react"
import { ParametrosIntegracaoContext } from "./ParametrosIntegracaoContext"

export function useParametrosIntegracaoContext() {
    return useContext(ParametrosIntegracaoContext)
}
